module.exports = require("@uirouter/angularjs");